export const INPUT_TYPES = {
  INPUT: "INPUT",
  TEXTAREA: "TEXTAREA",
  TEXTAREA_YES_NO: "TEXTAREA_YES_NO",
  SELECT: "SELECT",
  MULTISELECT: "MULTISELECT",
  CHECKBOX: "CHECKBOX",
  RADIO: "RADIO",
  HTML_BLOCK: "HTML_BLOCK",
};

export const PLACEMENTS = {
  ABILITIES: "ABILITIES",
  SPECIAL_NEEDS: "SPECIAL_NEEDS",
  WELLBEING: "WELLBEING",
};

export const PLACEMENT_LABELS = {
  ABILITIES: "Abilities",
  SPECIAL_NEEDS: "Special Needs",
  WELLBEING: "Wellbeing",
};
